import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { getSnapshot } from '@/auth/session-store'
import { AppShell } from '@/components/layout/app-shell'

/**
 * Layout autenticato.
 *
 * Rotta pathless (`_app`): raggruppa tutte le pagine dietro il guscio e il controllo
 * di sessione senza aggiungere un segmento all'URL.
 *
 * Al momento in cui `beforeLoad` gira la sessione è già decisa: `main.tsx` attende
 * `restoreSession()` prima di montare il router, quindi qui non esiste lo stato
 * `loading` e non serve una schermata di attesa intermedia.
 */
export const Route = createFileRoute('/_app')({
  beforeLoad: ({ location }) => {
    const { state } = getSnapshot()
    if (state.status !== 'authenticated') {
      throw redirect({
        to: '/login',
        // Dopo il login si torna dove si stava andando, non sempre in dashboard.
        search: { redirect: location.href },
      })
    }
  },
  component: () => (
    <AppShell>
      <Outlet />
    </AppShell>
  ),
})
